<template>
  <el-dialog title="修改密码" :visible.sync="dialogVisible" @close="$emit('update:visible',false)" width="30%">
    <div class="dialog_conwrap">
      <el-form ref="form" :model="form" label-width="120px" :rules="rules">
        <el-form-item label="旧密码:" prop="old_password">
          <el-input v-model="form.old_password" placeholder="请输入旧密码" type="password" autocomplete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="新密码:" prop="new_password">
          <el-input v-model="form.new_password" placeholder="请输入新密码" type="password" autocomplete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码:" prop="re_password">
          <el-input v-model="form.re_password" placeholder="请确认密码" type="password" autocomplete="new-password"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="settingPass" size="small">确认</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import crypto from 'crypto'
  import api from '@/api.js'
  export default {
    name: "goodsClassifyDialog",
    props: ["visible"],
    watch: {
      visible() {
        this.dialogVisible = this.visible;
      }
    },
    data() {
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.form.new_password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        dialogVisible: this.visible,
        form: {
          old_password:'',
          new_password:'',
          re_password:''
        },
        rules: {
          old_password: [
            { required: true, message: '请输入旧密码', trigger: 'blur' }
          ],
          new_password: [
            { required: true, message: '请输入新密码', trigger: 'blur' }
          ],
          re_password: [
            { required: true, message: '请确认密码', trigger: 'blur',validator: validatePass2 }
          ]
        },
        options: []
      };
    },
    methods: {
      settingPass() {
        let this_ = this
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this_.passSabmit()
          }
        });
      },
      passSabmit(){
        let self_ = this
        let data_ = {}
        for(let i in this.form){
          data_[i] = this.md5(this.form[i])
        }
        this.axios
            .post(api.company_edit_password, data_)
            .then(response => {
              if (response.data.code == 0) {
                this.dialogVisible = false
                self_.$confirm('密码设置成功,需重新登入', '提示', {
                  confirmButtonText: '确定',
                  showCancelButton:false,
                  closeOnClickModal:false,
                  closeOnPressEscape:false,
                  showClose: false,
                  type: 'warning'
                }).then(() => {
                  sessionStorage.removeItem('token');
                  sessionStorage.removeItem('keyid');
                  self_.$router.push('/login')
                }).catch(() => {
                });
              } 
            })
            .catch(response => {

            });
      },
      md5(password){
        let md5 = crypto.createHash("md5")
        md5.update(password) // this.pw2这是你要加密的密码
        return md5.digest('hex')
      }
    }
  };
</script>

